import React from 'react';
import { motion } from 'framer-motion';
export function FinalCTA() {
  return <section className="relative overflow-hidden bg-[#080C09] px-5 py-28 text-center md:py-36" data-id="element-93">
      <div className="pointer-events-none absolute left-1/2 top-1/2 h-72 w-72 -translate-x-1/2 -translate-y-1/2 rounded-full bg-gold/10 blur-[110px]" data-id="element-94" />
      <motion.div initial={{
      opacity: 0,
      y: 16
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="relative mx-auto max-w-4xl" data-id="element-95">
        <p className="text-xs font-bold uppercase tracking-[.22em] text-gold" data-id="element-96">
          La expedición continúa
        </p>
        <h2 className="mt-5 text-5xl font-semibold leading-[.95] text-stone-light md:text-7xl" data-id="element-97">
          Descubre los secretos de una de las civilizaciones más fascinantes de
          la historia.
        </h2>
        <p className="mx-auto mt-6 max-w-2xl leading-7 text-stone" data-id="element-98">
          Tu biblioteca digital para comprender, explorar y volver a mirar el
          mundo maya.
        </p>
        <a href="#oferta-premium" className="mt-9 inline-flex rounded-lg bg-gold px-8 py-4 text-sm font-bold text-dark transition hover:bg-gold-light" data-id="element-99">
          QUIERO ACCEDER AHORA
        </a>
      </motion.div>
    </section>;
}